class ImageGalleryDialog {
	constructor(dialog, images) {
		this.dialog = dialog;
		this.images = images;
		this.currentIndex = 0;

		this.imageElement = dialog.querySelector('[data-gallery-image]');
		this.counterElement = dialog.querySelector('[data-gallery-counter]');
		this.prevButton = dialog.querySelector('[data-gallery-prev]');
		this.nextButton = dialog.querySelector('[data-gallery-next]');
		this.closeButton = dialog.querySelector('[data-gallery-close]');

		this.bindEvents();
	}

	bindEvents() {
		this.prevButton.addEventListener('click', this.showPrevious.bind(this));
		this.nextButton.addEventListener('click', this.showNext.bind(this));
		this.closeButton.addEventListener('click', this.closeDialog.bind(this));

		this.dialog.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				this.closeDialog();
			} else if (e.key === 'ArrowLeft') {
				this.showPrevious();
			} else if (e.key === 'ArrowRight') {
				this.showNext();
			}
		});

		this.dialog.addEventListener('click', (e) => {
			if (e.target === this.dialog) {
				this.closeDialog();
			}
		});
	}

	open(index = 0) {
		this.currentIndex = index;
		this.updateImage();
		this.dialog.showModal();
		this.dialog.focus();
	}

	closeDialog() {
		this.dialog.close();
	}

	showPrevious() {
		if (this.currentIndex > 0) {
			this.currentIndex--;
			this.updateImage();
		}
	}

	showNext() {
		if (this.currentIndex < this.images.length - 1) {
			this.currentIndex++;
			this.updateImage();
		}
	}

	updateImage() {
		const image = this.images[this.currentIndex];

		this.imageElement.src = image.url;
		this.imageElement.alt = image.alt || '';

		this.counterElement.textContent = `${this.currentIndex + 1} / ${
			this.images.length
		}`;

		this.prevButton.disabled = this.currentIndex === 0;
		this.nextButton.disabled = this.currentIndex === this.images.length - 1;

		this.prevButton.setAttribute(
			'aria-label',
			this.currentIndex === 0
				? 'No hay imagen anterior'
				: 'Ver imagen anterior'
		);
		this.nextButton.setAttribute(
			'aria-label',
			this.currentIndex === this.images.length - 1
				? 'No hay imagen siguiente'
				: 'Ver imagen siguiente'
		);
	}
}

export default ImageGalleryDialog;
